/**
 * Currency Enumeration
 */

export enum CurrencyEnum {
  CLP = "CLP",
  USD = "USD",
  COP = "COP",
  PEN = "PEN",
  MXN = "MXN",
  BRL = "BRL",
  UF = "UF",
  CRC = "CRC",
  GTQ = "GTQ",
  HNL = "HNL",
  NIO = "NIO",
  PAB = "PAB",
}

export enum CurrencyEnumPayoutsCash {
  COP = "COP",
}

export enum CurrencyEnumCash {
  CLP = "CLP",
  USD = "USD",
  COP = "COP",
  PEN = "PEN",
  MXN = "MXN",
  BRL = "BRL",
}

export enum CurrencyCredomaticEnum {
  CRC = "CRC",
  GTQ = "GTQ",
  HNL = "HNL",
  NIO = "NIO",
}

export const CurrencySymbols: Record<string, string> = {
  [CurrencyEnum.CLP]: "$",
  [CurrencyEnum.USD]: "$",
  [CurrencyEnum.COP]: "$",
  [CurrencyEnum.PEN]: "S/.",
  [CurrencyEnum.MXN]: "$",
  [CurrencyCredomaticEnum.CRC]: "₡",
  [CurrencyCredomaticEnum.GTQ]: "Q",
  [CurrencyCredomaticEnum.HNL]: "L",
  [CurrencyCredomaticEnum.NIO]: "C$",
};



// WEBPACK FOOTER //
// ./src/shared/CurrencyEnum.ts